import { render, staticRenderFns } from "./CreateCorporateCustomer.vue?vue&type=template&id=a7141b50&"
import script from "./CreateCorporateCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateCorporateCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports